import React from "react";

const Nav = () => {
  return (
    <>

    <style jsx>{`
        .menubar-footer .inner-bar li {
          width: 33.3333333333% !important;
          padding: 0;
        }
        
        .alert-warning {
          color: #fff;
          background-color: #000;
          border-color: #000;
        }
        
        .bg-menuDark {
          background-color: #1f2937;
        }
        
        .bg-surface {
          background-color: #374151;
        }
        
        .text-button {
          font-size: 0.875rem;
          font-weight: 600;
        }
        
        .text-small {
          font-size: 0.75rem;
        }
        
        .text-secondary {
          color: #9ca3af;
        }
        
        .text-primary {
          color: #3b82f6;
        }
      `}</style>

      
      {/* Bottom Navigation */}
      <div className="menubar-footer fixed bottom-0 left-0 right-0 bg-gray-800 border-t border-gray-700">
        <ul className="inner-bar flex justify-around">
          {[
            { icon: "fas fa-home", text: "Home", link: "/user/wallet", active: true },
            { icon: "fas fa-chart-line", text: "Stake", link: "/user/deposit" },
            { icon: "fas fa-wallet", text: "Wallet", link: "/user/withdraw" },
            { icon: "fas fa-user", text: "Profile", link: "/user/profile" },
          ].map((item, index) => (
            <li key={index} className={item.active ? "active" : ""}>
              <a
                href={item.link}
                className="flex flex-col items-center py-2 px-4 text-sm hover:text-blue-400 transition-colors"
              >
                <i className={item.icon}></i>
                <span className="mt-1">{item.text}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Nav;
